// Dizzplace - rozwijane menu pod naglowkiem (mega).
//
// Panel lezy poza paskiem nawigacji, wiec sam CSS-owy :hover na pozycji menu go
// nie dosiega. Sterujemy z JS: najechanie na pozycje otwiera jej panel,
// zjechanie z naglowka zamyka po krotkiej zwloce (inaczej nie da sie przejechac
// mysza z pozycji menu na panel). Panel jest potomkiem naglowka, wiec wejscie
// w niego nie wywoluje zdarzenia opuszczenia naglowka.

(() => {
  const ZWLOKA = 180;

  const initHeaderMega = () => {
    const naglowek = document.querySelector('[data-header]');
    if (!naglowek || naglowek.dataset.megaGotowe === '1') return;

    const pozycje = [...naglowek.querySelectorAll('.site-nav__item')];
    if (pozycje.length === 0) return;
    naglowek.dataset.megaGotowe = '1';

    const panele = [...naglowek.querySelectorAll('[data-mega-panel]')];
    let zegar = null;

    const ustaw = (panel, otwarty) => {
      panel.dataset.open = otwarty ? 'true' : 'false';
      const wyzwalacz = naglowek.querySelector(`[data-mega-item="${panel.id}"] .site-nav__link`);
      if (wyzwalacz) wyzwalacz.setAttribute('aria-expanded', otwarty ? 'true' : 'false');
    };

    const zamknij = () => panele.forEach((panel) => ustaw(panel, false));

    const otworz = (panel) => {
      panele.forEach((inny) => ustaw(inny, inny === panel));
    };

    const anuluj = () => {
      if (zegar) clearTimeout(zegar);
      zegar = null;
    };

    const zaplanujZamkniecie = () => {
      anuluj();
      zegar = setTimeout(zamknij, ZWLOKA);
    };

    pozycje.forEach((pozycja) => {
      const id = pozycja.dataset.megaItem;
      const panel = id ? naglowek.querySelector(`#${CSS.escape(id)}`) : null;

      const wejscie = () => {
        anuluj();
        if (panel) {
          otworz(panel);
        } else {
          // Pozycja bez rozwijania - panel sasiada ma zniknac.
          zaplanujZamkniecie();
        }
      };

      pozycja.addEventListener('mouseenter', wejscie);
      pozycja.addEventListener('focusin', wejscie);

      /* Klawiatura: panel stoi w kodzie strony za ikonami, wiec zwykly Tab
         z „Produkty” przeskakiwal na nastepna pozycje i zamykal panel - linki
         w srodku byly nieosiagalne (audyt na slepo 27.10.2026). Tab z otwartej
         pozycji wchodzi do panelu, Tab z ostatniego linku panelu idzie do
         nastepnej pozycji menu, Shift+Tab z pierwszego wraca na pozycje. */
      if (!panel) return;
      const wyzwalacz = pozycja.querySelector('.site-nav__link');
      const linkiPanelu = () => [...panel.querySelectorAll('a[href], button:not([disabled])')].filter((el) => el.getClientRects().length);
      wyzwalacz?.addEventListener('keydown', (zdarzenie) => {
        if (zdarzenie.key !== 'Tab' || zdarzenie.shiftKey) return;
        otworz(panel);
        const lista = linkiPanelu();
        if (!lista.length) return;
        zdarzenie.preventDefault();
        lista[0].focus();
      });
      panel.addEventListener('keydown', (zdarzenie) => {
        if (zdarzenie.key !== 'Tab') return;
        const lista = linkiPanelu();
        if (!lista.length) return;
        if (zdarzenie.shiftKey && document.activeElement === lista[0]) {
          zdarzenie.preventDefault();
          wyzwalacz?.focus();
        } else if (!zdarzenie.shiftKey && document.activeElement === lista[lista.length - 1]) {
          const nastepna = pozycje[pozycje.indexOf(pozycja) + 1];
          const cel = nastepna?.querySelector('.site-nav__link');
          if (cel) {
            zdarzenie.preventDefault();
            zamknij();
            cel.focus();
          }
        }
      });
    });

    // Kursor wychodzi poza caly naglowek (razem z panelem) - zamykamy.
    naglowek.addEventListener('mouseleave', zaplanujZamkniecie);
    naglowek.addEventListener('mouseenter', anuluj);

    // Kursor na ikonach albo logo (dalej w naglowku) tez zamyka panel - zostawal
    // otwarty nad pol ekranu, gdy klient jechal z „Produkty” na lupe (audyt 27.10.2026).
    naglowek.querySelectorAll('.site-header__actions, .site-header__logo').forEach((strefa) => {
      strefa.addEventListener('mouseenter', zaplanujZamkniecie);
    });

    // Klawiatura: wyjscie focusa poza naglowek zamyka panel.
    naglowek.addEventListener('focusout', (zdarzenie) => {
      if (!naglowek.contains(zdarzenie.relatedTarget)) zamknij();
    });

    document.addEventListener('keydown', (zdarzenie) => {
      if (zdarzenie.key === 'Escape') zamknij();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderMega);
  } else {
    initHeaderMega();
  }

  // Edytor motywu podmienia HTML sekcji bez odswiezenia strony.
  document.addEventListener('shopify:section:load', initHeaderMega);
})();
